module.exports = __webpack_public_path__ + "img/k08.0ee10915.png";